<template>
  <div>
    <div class="ResourceGroup-title">
      <div>{{ $t('BSH.resourceGroup') }}</div>
    </div>
    <div class="searchBox">
      <Row :gutter="4">
        <!-- 选择公司 -->
        <div v-if="company == 1">
          <Col span="4">
            <Select v-model="companyId" filterable :placeholder="$t('alarms.common.pleaseSelectCompany')" :transfer="true" @on-change="">
              <Option :value="item.id" v-for="item in companyList" :key="item.id">{{item.name}}</Option>
            </Select>
          </Col>
        </div>
        <Col span="4">
          <Select v-model="accountId" filterable :placeholder="$t('alarms.common.pleaseSelectAccount')" :transfer="true">
            <Option :value="item.id" v-for="item in accountList" :key="item.id">{{item.name}}</Option>
          </Select>
        </Col>
        <Col span="4">
          <Input v-model="tagKey" :placeholder="$t('BSH.searchTagKey')" />
        </Col>
        <Col span="4">
          <Input v-model="tagValue" :placeholder="$t('BSH.searchTagValue')" />
        </Col>
        <Col span="4">
          <Input v-model="resourceGroupName" :placeholder="$t('BSH.searchResourceGroupName')" />
        </Col>
        <Col span="4">
          <Button
            type="primary"
            v-hasPermission="['monitor:resourceGroupMonitor:page']"
            @click="getData"
          >{{ $t("message.select") }}</Button>
          <Button
            type="primary"
            v-hasPermission="['monitor:resourceGroupMonitor:add']"
            @click="addOrUpdateResourceGroup(1)"
          >{{ $t("BSH.add") }}</Button>
        </Col>
      </Row>
    </div>
    <div>
      <Table
        :no-data-text="$t('common.noData')"
        :columns="columns"
        :data="resourceGroupList"
        style="width: 100%;">
        <template slot-scope="{ row, index }" slot="operation">
          <Dropdown transfer @on-click="clickDropdownItem($event, row.id)">
            <Button type="primary">
              {{ $t("common.operation") }}
              <Icon type="ios-arrow-down"></Icon>
            </Button>
            <DropdownMenu slot="list">
              <DropdownItem
                name="1"
                v-hasPermission="['monitor:resourceGroupMonitor:operationLog']"
              >{{ $t("alarms.common.operationLog") }}</DropdownItem>
              <DropdownItem
                name="2"
                v-hasPermission="['monitor:resourceGroupMonitor:resourceSyncLog']"
              >{{ $t("alarms.common.resourceSyncLog") }}</DropdownItem>
              <DropdownItem
                name="3"
                v-hasPermission="['monitor:resourceGroupMonitor:detail']"
              >{{ $t("alarms.common.edit") }}</DropdownItem>
              <DropdownItem
                name="4"
                v-hasPermission="['monitor:resourceGroupMonitor:delete']"
              >{{ $t("alarms.common.delete") }}</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </template>
      </Table>
      <Page
        :current="current"
        :total="dataTotal"
        show-sizer
        :page-size="pageSize"
        @on-change="changePage"
        @on-page-size-change="changeSize"
        :transfer="true"
        style="margin: 10px 0 20px"
      ></Page>
      <!-- 操作日志 -->
      <Modal
        :title="$t('operation_log.operationLog')"
        v-model="dialogVisible"
        width="55%"
        footer-hide
      >
        <Table
          :no-data-text="$t('common.noData')"
          :loading="showLoading"
          :columns="column"
          :data="operationLogData"
          style="width: 100%;"
          class="table-css"
          height="500"
        ></Table>
      </Modal>
      <!-- 资源同步记录 -->
      <Modal
        :title="$t('alarms.common.resourceSyncLog')"
        v-model="showSyncLog"
        width="55%"
        footer-hide
      >
        <div class="searchBox">
          <Row :gutter="4">
            <Col span="4">
              <Input v-model="uniqueIdentifierOfResource" :placeholder="$t('BSH.searchUniqueIdentifierOfResource')" />
            </Col>
            <Col span="4">
              <Button
                type="primary"
                @click="getSyncData"
              >{{ $t("message.select") }}</Button>
            </Col>
          </Row>
        </div>
        <Table
          :no-data-text="$t('common.noData')"
          :loading="syncLogLoading"
          :columns="syncColumn"
          :data="syncLogData"
          style="width: 100%;"
          class="table-css"
          height="400"
        ></Table>
        <Page
          :current="syncCurrent"
          :total="syncTotal"
          show-sizer
          :page-size="syncPageSize"
          @on-change="changeSyncPage"
          @on-page-size-change="changeSyncSize"
          :transfer="true"
          style="margin: 10px 0 20px"
        ></Page>
      </Modal>
      <!-- 删除弹框 -->
      <Modal v-model="showDelModal" width="360" :mask-closable="false">
        <p slot="header" style="color:#f60;text-align:center">
          <Icon type="ios-information-circle"></Icon>
          <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
        </p>
        <div style="text-align:center">
          <p>{{ massage }}</p>
        </div>
        <div slot="footer">
          <Button
            type="error"
            size="large"
            long
            @click="deleteItem(id)"
            :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
          >
        </div>
      </Modal>
    </div>
    <add-or-update-resource-group v-if="showModal" ref="addOrUpdate"></add-or-update-resource-group>
  </div>
</template>

<script>
import {getCookie} from "../../../utils/cookieUtil";
import AddOrUpdateResourceGroup from "./AddOrUpdateResourceGroup.vue";

export default {
  name: "ResourceGroup",
  components: {
    AddOrUpdateResourceGroup
  },
  data() {
    return {
      company: getCookie(global.companyId),
      title: "",
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      syncCurrent: 1,
      syncTotal: 0,
      syncPageSize: 10,
      showModal: false,
      dialogVisible: false,
      showSyncLog: false,
      showDelModal: false,
      isDisable: false,
      showLoading: false,
      syncLogLoading: false,
      companyId: "",
      accountId: "",
      tagKey: "",
      tagValue: "",
      resourceGroupName: "",
      companyList: [],
      accountList: [],
      resourceGroupList: [],
      columns: [
        {
          title: this.$t("BSH.resourceGroupName"),
          key: "resourceGroupName"
        },
        {
          title: this.$t("BSH.account"),
          key: "accountName"
        },
        {
          title: this.$t("BSH.region"),
          key: "regionName"
        },
        {
          title: this.$t("BSH.tagKey"),
          key: "tagKey"
        },
        {
          title: this.$t("BSH.tagValue"),
          key: "tagValue"
        },
        {
          title: this.$t("common.operation"),
          slot: "operation",
        }
      ],
      column: [
        {
          title: this.$t('ticket.comment.operationType'),
          key: "operationType"
        },
        {
          title: this.$t('ticket.comment.description'),
          key: "description"
        },
        {
          title: this.$t('operation_log.operationOriginValue'),
          key: "operationOriginValue"
        },
        {
          title: this.$t('operation_log.operationNewValue'),
          key: "operationNewValue"
        },
        {
          title: this.$t('operation_log.createdBy'),
          key: "createdBy"
        },
        {
          title: this.$t('operation_log.createdTime'),
          key: "createdTime"
        }
      ],
      syncColumn: [
        {
          title: this.$t("BSH.uniqueIdentifierOfResource"),
          key: "resourceIdentifier"
        },
        {
          title: "Tag: Name",
          key: "resourceName"
        },
        {
          title: this.$t('alarms.billing.resourceType'),
          key: "resourceTypeName"
        },
        {
          title: this.$t("BSH.region"),
          key: "regionName"
        },
        {
          title: this.$t("OriginalBillEntry.syncTime"),
          key: "createdTime"
        },
        {
          title: this.$t('OriginalBillEntry.syncType'),
          key: "syncTypeName"
        }
      ],
      operationLogData: [],
      syncLogData: [],
      uniqueIdentifierOfResource: "",
      massage: "",
      id: "",
      groupId: ""
    }
  },
  mounted() {
    this.$api.company
      .getCompanyDropDownBox("userName", getCookie(global.cookieName))
      .then((res) => {
        this.companyList = res.data;
        this.companyId = this.companyList[0].id;
        this.getData();
        this.$api.account
          .getAWSAccountByCompanyId("companyId", this.companyId)
          .then(res => {
            this.accountList = res.data;
          });
      });
  },
  methods: {
    getData() {
      let data = {
        companyId: this.companyId,
        accountId: this.accountId,
        tagKey: this.tagKey,
        tagValue: this.tagValue,
        resourceGroupName: this.resourceGroupName,
        pageSize: this.pageSize,
        pageNum: this.current
      }
      this.$api.resourcePermis.queryResourceGroupList(data).then(res => {
        this.resourceGroupList = res.data.records;
        // 当前页
        this.current = res.data.current;
        // 总条数
        this.dataTotal = res.data.total;
      })
    },
    getSyncData() {
      const data = {
        resourceGroupId: this.groupId,
        resourceIdentifier: this.uniqueIdentifierOfResource,
        pageSize: this.syncPageSize,
        pageNum: this.syncCurrent
      }
      this.$api.resourcePermis.queryResourceSyncLog(data).then(res => {
        this.syncLogData = res.data.records;
        // 当前页
        this.syncCurrent = res.data.current;
        // 总条数
        this.syncTotal = res.data.total;
      }).finally(() => {
        this.syncLogLoading = false;
      })
    },
    // 添加或编辑资源组
    addOrUpdateResourceGroup(i, id) {
      this.title = i === 1 ? this.$t("BSH.add") : this.$t("BillingServices.edit");
      this.showModal = true;
      this.$nextTick(() => {
        if (i === 1) {
          this.$router.push({path:'/monitor/addOrUpdateResourceGroup'});
        } else {
          this.$router.push({path:'/monitor/addOrUpdateResourceGroup?id=' + id});
        }
      })
    },
    changePage(current) {
      this.current = current;
      this.getData();
    },
    changeSize(pageSize) {
      this.pageSize = pageSize;
      this.getData();
    },
    changeSyncPage(current) {
      this.syncCurrent = current;
      this.getSyncData();
    },
    changeSyncSize(pageSize) {
      this.syncPageSize = pageSize;
      this.getSyncData();
    },
    // 点击操作下拉选项
    clickDropdownItem(e, id) {
      if (e == 1) {
        this.showOperationLog(id)
      } else if (e == 2) {
        this.showSyncLogs(id)
      } else if (e == 3) {
        this.addOrUpdateResourceGroup(2, id)
      } else if (e == 4) {
        this.deleteItem(id, 1)
      }
    },
    // 查看操作日志
    showOperationLog(id) {
      this.dialogVisible = true;
      this.showLoading = true;
      this.$api.resourcePermis.queryOperationLogList(id).then(res => {
        this.operationLogData = res.data;
      }).finally(() => {
        this.showLoading = false;
      })
    },
    // 查看资源同步记录
    showSyncLogs(id) {
      this.syncCurrent = 1;
      this.syncPageSize = 10;
      this.uniqueIdentifierOfResource = "";
      this.showSyncLog = true;
      this.groupId = id;
      this.syncLogLoading = true;
      this.getSyncData();
    },
    // 删除资源组
    deleteItem(id, i) {
      let data = {
        id: id
      }
      if (i === 1) {
        this.$api.resourcePermis.deleteResourceGroup(data).then(res => {
          this.id = id;
          this.massage = res.data;
          this.showDelModal = true;
        })
      } else {
        this.isDisable = true;
        data.confirmDelete = true;
        this.$api.resourcePermis.deleteResourceGroup(data).then(res => {
          this.$Message.success(this.$t('resourceLifecycle.response.deleteSuccess'));
          this.getData();
        }).finally(() => {
          this.isDisable = false;
          this.showDelModal = false;
        })
      }
    }
  }
}
</script>

<style scoped>
.ResourceGroup-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0 8px 4px;
  font-weight: 600;
  overflow: hidden;
}
.searchBox {
  height: 51px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/ResourceGroup/ResourceGroup.vue